export default __webpack_public_path__ + "static/media/lynnGame.f4a97fa8.png";